import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
//import { NzMessageModule } from 'ng-zorro-antd/message';
import en from '@angular/common/locales/en';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CalendarModule, DateAdapter } from 'angular-calendar';
//import { SchedulerModule } from 'angular-calendar-scheduler';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { en_US, NzCarouselModule, NzMessageModule, NZ_I18N } from 'ng-zorro-antd';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ApiAuthorizationModule } from 'src/api-authorization/api-authorization.module';
import { AuthorizeInterceptor } from 'src/api-authorization/authorize.interceptor';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { API_BASE_URL, MemberCardsClient, MemberContributionsClient, MembersClient, MemberTransactionsClient, OrdersClient } from './cms-bagha-api';
import { HomeComponent } from './home/home.component';
import { NavSideMenuComponent } from './nav-side-menu/nav-side-menu.component';
import { NavTopMenuComponent } from './nav-top-menu/nav-top-menu.component';
import { EnvService } from './env.service';
import { EnvServiceProvider } from './env.service.provider';
import { NoticeListComponent } from './notice-list/notice-list.component';
import { AngularPrimengModule } from './angular-primeng.module';
import { ApplicationSharedModule } from './application-shared/application-shared.module';
import { AngulerNgzorroModule } from './anguler-ngzorro.module';
import { AngularMaterialModule } from './angular-material.module';
import { CardModule } from 'primeng/card';
import { EventListComponent } from './event-list/event-list.component';
registerLocaleData(en);


export function getBaseUrl(env: EnvService): string {
  //return () =>
  //    oidcConfigService.load_using_custom_stsServer(
  //        environment.identityUrl
  //    );
  //console.log(env);
  return env.apiBaseUrl;
}

@NgModule({
  declarations: [
    AppComponent,
    NavTopMenuComponent,

    NavSideMenuComponent,

    HomeComponent,
    NoticeListComponent,
    EventListComponent,

  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    NgHttpLoaderModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
     
    AppRoutingModule,
    
    ApiAuthorizationModule,
    
    NzCarouselModule,
    NzMessageModule,
    ModalModule.forRoot(),
    
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    //SchedulerModule.forRoot({ locale: 'en', headerDateFormat: 'daysRange' })
    CardModule

  ],
  entryComponents: [

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizeInterceptor, multi: true },
    { provide: API_BASE_URL, useFactory: getBaseUrl, deps: [EnvService] },
    { provide: NZ_I18N, useValue: en_US },
    
    MembersClient,
    MemberCardsClient,
    MemberContributionsClient,
    MemberTransactionsClient,
    OrdersClient,
    HomeComponent,
    EnvServiceProvider,
    NoticeListComponent,
    EventListComponent,

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
